(function () {
  angular.module("akitabox.ui.dialogs.document.upload", [
    "akitabox.core.constants",
    "akitabox.core.services.document",
    "akitabox.core.services.env",
    "akitabox.core.services.file",
    "akitabox.core.utils",
  ]);
})();
